import { AlternateUrl } from "@/generated/raid";

export const alternateUrlDataGenerator = (): AlternateUrl => {
  return {
    url: "",
  };
};
